(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ourstory-timeline"] && !Shopify.designMode) return;
  try {
    
const revealerpoint=100;function reveal(){const revealers=document.querySelectorAll(".timeline_card-content"),position=element=>{const data={top:element.getBoundingClientRect().top,bottom:element.getBoundingClientRect().bottom};return data};revealers.forEach(card=>{const windowheight=window.innerHeight-150;if(position(card).top<windowheight){const animationClass=card.dataset.animation;card.firstElementChild.classList.remove("off"),card.classList.add(animationClass)}})}window.addEventListener("scroll",reveal);reveal();

  } catch(e) { console.error(e); }
})();
})();
